import Container from "@mui/material/Container";
import PrizepicksTable from "./PrizepicksTable";

export default function PrizepicksPage() {

  return (
    <Container sx={{ margin: '5'}}>
      <PrizepicksTable />
    </Container>
  );
}